import { Event } from '@/types/events';

export const distributeEvents = (events: Event[]) => {
  // Sort events by date and status priority
  const sortedEvents = [...events].sort((a, b) => {
    // First sort by date
    const dateComparison = new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
    if (dateComparison !== 0) return dateComparison;
    
    // Then by status priority
    const statusPriority = {
      in_progress: 1,
      approved: 2,
      pending_approval: 3,
      draft: 4,
      completed: 5,
      cancelled: 6
    };
    
    return (statusPriority[a.status as keyof typeof statusPriority] || 99) -
           (statusPriority[b.status as keyof typeof statusPriority] || 99);
  });

  const leftEvents: Event[] = [];
  const rightEvents: Event[] = [];

  // Distribute events evenly between columns while maintaining chronological order
  sortedEvents.forEach((event, index) => {
    if (index % 2 === 0) {
      leftEvents.push(event);
    } else {
      rightEvents.push(event);
    }
  });

  return { leftEvents, rightEvents };
};